import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, Play, Pause, Trash2, Link2, CheckCircle, Loader, AlertTriangle } from 'lucide-react';
import api from '../api';

// Real SVG logos for all platforms
const PLATFORM_LOGOS = {
  gmail: () => (
    <svg width="22" height="22" viewBox="0 0 48 48">
      <path fill="#EA4335" d="M6 8h36l-18 14L6 8z"/>
      <path fill="#FBBC05" d="M6 8v32l12-16L6 8z"/>
      <path fill="#34A853" d="M42 8v32L30 24l12-16z"/>
      <path fill="#4285F4" d="M6 40h36L30 24 24 28.5 18 24 6 40z"/>
      <path fill="#C5221F" d="M6 8l18 14 18-14H6z"/>
    </svg>
  ),
  googleSheets: () => (
    <svg width="22" height="22" viewBox="0 0 48 48">
      <rect width="48" height="48" rx="6" fill="#0F9D58"/>
      <rect x="10" y="14" width="28" height="3" rx="1" fill="white" opacity="0.9"/>
      <rect x="10" y="21" width="28" height="3" rx="1" fill="white" opacity="0.9"/>
      <rect x="10" y="28" width="28" height="3" rx="1" fill="white" opacity="0.9"/>
      <rect x="10" y="35" width="18" height="3" rx="1" fill="white" opacity="0.9"/>
      <rect x="22" y="14" width="2" height="24" fill="white" opacity="0.4"/>
    </svg>
  ),
  googleCalendar: () => (
    <svg width="22" height="22" viewBox="0 0 48 48">
      <rect width="48" height="48" rx="6" fill="white" stroke="#e0e0e0"/>
      <rect x="4" y="4" width="40" height="14" rx="4" fill="#EA4335"/>
      <text x="24" y="38" textAnchor="middle" fontSize="18" fontWeight="900" fill="#1a73e8">
        {new Date().getDate()}
      </text>
      <rect x="14" y="4" width="4" height="8" rx="2" fill="white"/>
      <rect x="30" y="4" width="4" height="8" rx="2" fill="white"/>
    </svg>
  ),
  googleDrive: () => (
    <svg width="22" height="22" viewBox="0 0 48 48">
      <path fill="#FBBC05" d="M6 36l6-10h24l6 10H6z"/>
      <path fill="#EA4335" d="M18 8L6 28l6 8 12-20-6-8z"/>
      <path fill="#34A853" d="M30 8L18 28l6 8 18-28h-12z"/>
    </svg>
  ),
  telegram: () => (
    <svg width="22" height="22" viewBox="0 0 48 48">
      <circle cx="24" cy="24" r="24" fill="#229ED9"/>
      <path fill="white" d="M10.2 23.4l5.8 2.2 2.2 7 2.8-2.8 5.8 4.4 8-16.8-24.6 6zM18 25.2l10-6.4-6.4 7.2-.2 3.4-3.4-4.2z"/>
    </svg>
  ),
  slack: () => (
    <svg width="22" height="22" viewBox="0 0 48 48">
      <path fill="#E01E5A" d="M10 28.5a3.5 3.5 0 01-3.5 3.5A3.5 3.5 0 013 28.5 3.5 3.5 0 016.5 25H10v3.5zm1.8 0a3.5 3.5 0 013.5-3.5 3.5 3.5 0 013.5 3.5v8.7A3.5 3.5 0 0115.3 41a3.5 3.5 0 01-3.5-3.5v-9z"/>
      <path fill="#36C5F0" d="M15.3 10a3.5 3.5 0 01-3.5-3.5A3.5 3.5 0 0115.3 3a3.5 3.5 0 013.5 3.5V10h-3.5zm0 1.8a3.5 3.5 0 013.5 3.5 3.5 3.5 0 01-3.5 3.5H6.5A3.5 3.5 0 013 15.3a3.5 3.5 0 013.5-3.5h8.8z"/>
      <path fill="#2EB67D" d="M33.7 15.3a3.5 3.5 0 013.5-3.5A3.5 3.5 0 0141 15.3a3.5 3.5 0 01-3.5 3.5H33.7v-3.5zm-1.8 0a3.5 3.5 0 01-3.5 3.5 3.5 3.5 0 01-3.5-3.5V6.5A3.5 3.5 0 0128.4 3a3.5 3.5 0 013.5 3.5v8.8z"/>
      <path fill="#ECB22E" d="M28.4 33.7a3.5 3.5 0 013.5 3.5A3.5 3.5 0 0128.4 41a3.5 3.5 0 01-3.5-3.5V33.7h3.5zm0-1.8a3.5 3.5 0 01-3.5-3.5 3.5 3.5 0 013.5-3.5h8.8A3.5 3.5 0 0141 28.4a3.5 3.5 0 01-3.5 3.5h-9.1z"/>
    </svg>
  ),
  whatsapp: () => (
    <svg width="22" height="22" viewBox="0 0 48 48">
      <circle cx="24" cy="24" r="24" fill="#25D366"/>
      <path fill="white" d="M34.5 13.5C32 11 28.6 9.5 24.9 9.5c-7.7 0-14 6.3-14 14 0 2.5.6 4.9 1.9 7l-2 7.3 7.5-2c2 1.1 4.3 1.7 6.6 1.7 7.7 0 14-6.3 14-14 0-3.7-1.5-7.2-4.4-10zm-9.6 21.5c-2.1 0-4.2-.6-6-1.6l-.4-.3-4.4 1.2 1.2-4.3-.3-.4c-1.1-1.8-1.7-3.9-1.7-6.1 0-6.2 5.1-11.3 11.3-11.3 3 0 5.8 1.2 7.9 3.3 2.1 2.1 3.3 4.9 3.3 7.9 0 6.3-5.1 11.6-11.3 11.6z"/>
    </svg>
  ),
  stripe: () => (
    <svg width="22" height="22" viewBox="0 0 48 48">
      <rect width="48" height="48" rx="8" fill="#635BFF"/>
      <path fill="white" d="M22.5 18c0-1.7 1.4-2.4 3.5-2.4 3.1 0 7 1 9.5 2.7v-9C33 7.8 29.5 7 25.7 7 17.7 7 12.5 11 12.5 18.3c0 11.2 15.5 9.4 15.5 14.2 0 2-1.7 2.6-4 2.6-3.5 0-7.9-1.4-11.4-3.4V41c3.8 1.6 7.7 2.3 11.4 2.3 8.2 0 13.8-4 13.8-11.4C37.8 20.8 22.5 22.9 22.5 18z"/>
    </svg>
  ),
  airtable: () => (
    <svg width="22" height="22" viewBox="0 0 48 48">
      <rect width="48" height="48" rx="8" fill="#FF6B35"/>
      <text x="24" y="33" textAnchor="middle" fontSize="22" fontWeight="900" fill="white">A</text>
    </svg>
  ),
  notion: () => (
    <svg width="22" height="22" viewBox="0 0 48 48">
      <rect width="48" height="48" rx="8" fill="#fff"/>
      <text x="24" y="36" textAnchor="middle" fontSize="28" fontWeight="900" fill="#000">N</text>
    </svg>
  ),
  webhook: () => (
    <svg width="22" height="22" viewBox="0 0 48 48">
      <rect width="48" height="48" rx="8" fill="#6366f1"/>
      <path fill="white" d="M24 8a8 8 0 100 16 8 8 0 000-16zm0 24a8 8 0 100 16 8 8 0 000-16zm-12-8a6 6 0 100 12 6 6 0 000-12zm24 0a6 6 0 100 12 6 6 0 000-12z"/>
    </svg>
  ),
  sendgrid: () => <div style={{ width: 22, height: 22, background: '#1A82E2', borderRadius: 5, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 900, color: 'white' }}>SG</div>,
  mailgun: () => <div style={{ width: 22, height: 22, background: '#F06B26', borderRadius: 5, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 900, color: 'white' }}>MG</div>,
  brevo: () => <div style={{ width: 22, height: 22, background: '#0B996E', borderRadius: 5, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 900, color: 'white' }}>BR</div>,
  zoho: () => <div style={{ width: 22, height: 22, background: '#E42527', borderRadius: 5, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 900, color: 'white' }}>ZO</div>,
  smtp: () => <div style={{ width: 22, height: 22, background: '#6366f1', borderRadius: 5, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 900, color: 'white' }}>SMTP</div>,
};

const getPlatformLogo = (platform) => {
  const Logo = PLATFORM_LOGOS[platform];
  return Logo ? <Logo /> : (
    <div style={{ width: 22, height: 22, background: 'var(--bg4)', borderRadius: 5, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 900, color: 'var(--text3)' }}>
      {platform.substring(0, 2).toUpperCase()}
    </div>
  );
};

const PLATFORM_NAMES = {
  gmail: 'Gmail', googleSheets: 'Google Sheets', googleCalendar: 'Google Calendar',
  googleDrive: 'Google Drive', telegram: 'Telegram', slack: 'Slack',
  whatsapp: 'WhatsApp Business', stripe: 'Stripe', airtable: 'Airtable',
  notion: 'Notion', webhook: 'Webhook', sendgrid: 'SendGrid',
  mailgun: 'Mailgun', brevo: 'Brevo', zoho: 'Zoho Mail', smtp: 'Custom SMTP',
};

export default function AutomationDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [automation, setAutomation] = useState(null);
  const [connectedPlatforms, setConnectedPlatforms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toggling, setToggling] = useState(false);

  const load = async () => {
    try {
      const [aRes, cRes, gRes, tRes] = await Promise.all([
        api.get(`/automations/${id}`),
        api.get('/credentials'),
        api.get('/oauth/google/status'),
        api.get('/integrations/telegram/status'),
      ]);
      setAutomation(aRes.data);
      const connected = cRes.data.map(c => c.platform);
      if (gRes.data.connected) connected.push('gmail', 'googleSheets', 'googleCalendar', 'googleDrive');
      if (tRes.data.connected) connected.push('telegram');
      setConnectedPlatforms([...new Set(connected)]);
    } catch { navigate('/'); }
    finally { setLoading(false); }
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 4000);
    return () => clearInterval(t);
  }, [id]);

  const toggle = async () => {
    setToggling(true);
    try { await api.post(`/automations/${id}/toggle`); await load(); }
    catch (e) { alert(e.response?.data?.detail || 'Failed'); }
    finally { setToggling(false); }
  };

  const remove = async () => {
    if (!window.confirm('Delete this automation permanently?')) return;
    await api.delete(`/automations/${id}`);
    navigate('/');
  };

  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '60vh' }}>
      <Loader size={22} color="var(--accent)" style={{ animation: 'spin 1s linear infinite' }} />
    </div>
  );

  if (!automation) return null;

  const isBuilding = automation.status === 'building';
  const isActive = automation.status === 'active';
  const isFailed = automation.status === 'failed';
  const requiredIntegrations = automation.required_integrations || [];
  const missingPlatforms = requiredIntegrations.filter(p => !connectedPlatforms.includes(p));

  return (
    <div style={{ maxWidth: 640, margin: '0 auto' }} className="fade-in">
      <button className="btn btn-ghost btn-sm" style={{ marginBottom: 24, color: 'var(--text2)' }} onClick={() => navigate('/')}>
        <ArrowLeft size={14} /> Back
      </button>

      {/* Main card */}
      <div style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', padding: '22px 24px', marginBottom: 14 }}>
        <div style={{ marginBottom: 16 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
            <h2 style={{ fontSize: 20, fontWeight: 800, letterSpacing: '-0.3px' }}>{automation.title}</h2>
            <span className={`badge badge-${automation.status}`} style={{ fontSize: 11, fontWeight: 800 }}>
              {isBuilding && <Loader size={9} style={{ animation: 'spin 1s linear infinite' }} />}
              {isActive && <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'var(--green)', animation: 'pulse-ring 2s infinite', display: 'inline-block' }} />}
              {isBuilding ? 'Building' : isActive ? 'Active' : automation.status === 'ready' ? 'Ready' : automation.status === 'paused' ? 'Paused' : isFailed ? 'Failed' : 'Stopped'}
            </span>
          </div>
          <p style={{ fontSize: 14, color: 'var(--text2)', lineHeight: 1.7, fontWeight: 500 }}>{automation.description}</p>
        </div>

        {/* States */}
        {isBuilding && (
          <div style={{ padding: '13px 16px', background: 'var(--accent-glow)', borderRadius: 9, display: 'flex', alignItems: 'center', gap: 10, fontSize: 14, color: 'var(--accent3)', fontWeight: 600, marginBottom: 16, border: '1px solid rgba(99,102,241,0.2)' }}>
            <Loader size={15} style={{ animation: 'spin 1s linear infinite', flexShrink: 0 }} />
            Building your automation — usually takes 20–30 seconds. Updates automatically.
          </div>
        )}

        {isFailed && (
          <div style={{ padding: '13px 16px', background: 'var(--red-bg)', borderRadius: 9, display: 'flex', alignItems: 'flex-start', gap: 10, fontSize: 14, color: 'var(--red)', fontWeight: 600, marginBottom: 16, border: '1px solid rgba(239,68,68,0.2)' }}>
            <AlertTriangle size={16} style={{ flexShrink: 0, marginTop: 1 }} />
            Build failed. Delete this and try again with a more specific description.
          </div>
        )}

        {/* Missing connections warning */}
        {!isBuilding && !isFailed && missingPlatforms.length > 0 && (
          <div style={{ padding: '13px 16px', background: 'var(--yellow-bg)', borderRadius: 9, display: 'flex', alignItems: 'flex-start', gap: 10, fontSize: 14, color: 'var(--yellow)', fontWeight: 600, marginBottom: 16, border: '1px solid rgba(245,158,11,0.25)' }}>
            <AlertTriangle size={15} style={{ flexShrink: 0, marginTop: 1 }} />
            Connect <strong>{missingPlatforms.map(p => PLATFORM_NAMES[p] || p).join(', ')}</strong> below before activating this automation.
          </div>
        )}

        {/* Actions */}
        {!isBuilding && !isFailed && (
          <div style={{ display: 'flex', gap: 8 }}>
            <button className={`btn ${isActive ? 'btn-secondary' : 'btn-primary'}`}
              style={{ flex: 1, justifyContent: 'center', fontWeight: 700, fontSize: 15 }}
              onClick={toggle} disabled={toggling}>
              {toggling
                ? <Loader size={15} style={{ animation: 'spin 1s linear infinite' }} />
                : isActive ? <><Pause size={15} /> Pause</> : <><Play size={15} /> Activate</>}
            </button>
            <button className="btn btn-danger btn-icon" style={{ width: 44, height: 44 }} onClick={remove}>
              <Trash2 size={16} />
            </button>
          </div>
        )}
        {isFailed && (
          <button className="btn btn-danger" style={{ width: '100%', justifyContent: 'center', fontWeight: 700 }} onClick={remove}>
            <Trash2 size={15} /> Delete and try again
          </button>
        )}
      </div>

      {/* Required connections */}
      {requiredIntegrations.length > 0 && (
        <div style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', padding: '22px 24px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
            <Link2 size={16} color="var(--accent3)" />
            <h2 style={{ fontSize: 16, fontWeight: 800 }}>Required connections</h2>
          </div>
          <p style={{ fontSize: 13, color: 'var(--text2)', marginBottom: 16, fontWeight: 500 }}>
            {missingPlatforms.length === 0
              ? '✅ All connections are ready. You can activate this automation.'
              : 'Connect these services for your automation to work.'}
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 9 }}>
            {requiredIntegrations.map(platform => {
              const isConnected = connectedPlatforms.includes(platform);
              return (
                <div key={platform} style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  padding: '13px 16px', borderRadius: 10,
                  background: isConnected ? 'rgba(34,197,94,0.07)' : 'var(--bg3)',
                  border: `1px solid ${isConnected ? 'var(--green-border)' : 'var(--border2)'}`,
                  transition: 'all 0.2s'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <div style={{ width: 36, height: 36, borderRadius: 9, background: 'var(--bg4)', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid var(--border)', flexShrink: 0 }}>
                      {getPlatformLogo(platform)}
                    </div>
                    <span style={{ fontSize: 15, fontWeight: 700 }}>
                      {PLATFORM_NAMES[platform] || platform}
                    </span>
                  </div>
                  {isConnected
                    ? <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: 'var(--green)', fontWeight: 800 }}>
                        <CheckCircle size={15} /> Connected
                      </div>
                    : <button className="btn btn-primary btn-sm" onClick={() => navigate('/integrations')} style={{ fontWeight: 700 }}>
                        Connect
                      </button>
                  }
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
